/**
 * Plattform-Betreiber landen nach der Anmeldung zuerst in der Plattform-Verwaltung. Erst der Button
 * „Testumgebung" öffnet das CRM (Test-Betrieb mit Testdaten). Dieser Merker gilt nur für die aktuelle
 * Browser-Sitzung und wird bei Anmeldung und Abmeldung zurückgesetzt.
 */
const KEY = "mavatech_crm_entered";

export function hasEnteredCrm(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function markCrmEntered() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    /* ohne Speicher: Betreiber landet bei jedem Aufruf von "/" wieder in der Plattform */
  }
}

export function resetCrmEntered() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* egal */
  }
}
